export default __webpack_public_path__ + "static/gallery-art-architecture-2ee5dc35aa8d86032ce7b9c46ed92792.jpg";